import React, {Component} from 'react';
import Conclusion from './conclusion';
import RealTime from './realTime';
import Detail from './detail';
import { chatColor } from '../../../../../utils/common';
import './index.less';

class Index extends Component {
  render() {
    const { themeColor, i18n, summary, result, paperInfo, handleClick, videoUrl, useful, updateUserInfo } = this.props;
    return (
      <div className="mobile-summary">
        <Conclusion updateUserInfo={updateUserInfo} useful={useful} chatColor={chatColor[themeColor]} themeColor={themeColor} summary={summary} i18n={i18n} />
        <RealTime paperInfo={paperInfo} handleClick={handleClick} videoUrl={videoUrl}
                  themeColor={themeColor} result={result} summary={summary} i18n={i18n} />
        <Detail chatColor={chatColor[themeColor]} themeColor={themeColor} summary={summary} i18n={i18n} />
      </div>
    );
  }
}

export default Index;
